import React from 'react';
import { Reveal } from './Reveal';
import { ArrowRight } from 'lucide-react';
export const TrackProgressSection = () => {
  return <section className="py-12 md:py-16 px-[5vw] bg-white overflow-hidden" data-id="element-630">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-631">
        {/* Left: Visual Mockup */}
        <Reveal data-id="element-632">
          <div className="relative flex justify-center lg:justify-end pr-0 lg:pr-10" data-id="element-633">
            {/* Phone Mockup */}
            <div className="w-[260px] bg-bg rounded-[40px] p-5 shadow-[0_32px_80px_rgba(0,0,0,0.12)] border-[6px] border-white relative z-10" data-id="element-634">
              <div className="mb-6" data-id="element-635">
                <p className="text-[10px] font-bold text-ink-soft tracking-wider mb-1" data-id="element-636">
                  FATURAMENTO DO MÊS
                </p>
                <div className="font-serif font-bold text-[34px] text-gold leading-none mb-1" data-id="element-637">
                  R$ 7.540
                </div>
                <p className="text-xs text-ink-soft" data-id="element-638">
                  Abril 2026 · Lucro: R$ 4.373
                </p>
              </div>

              {/* CSS Bar Chart — organic growth with some dips */}
              <div className="flex items-end justify-between gap-1.5 mt-8 border-b border-line pb-2" style={{
              height: '160px'
            }} data-id="element-639">
                <div className="w-full flex flex-col items-center justify-end h-full gap-1" data-id="element-640">
                  <div className="w-full rounded-t-md" style={{
                  height: '48px',
                  backgroundColor: 'var(--rose)',
                  opacity: 0.5
                }} data-id="element-641"></div>
                  <span className="text-[9px] text-ink-soft" data-id="element-642">Jan</span>
                </div>
                <div className="w-full flex flex-col items-center justify-end h-full gap-1" data-id="element-643">
                  <div className="w-full rounded-t-md" style={{
                  height: '67px',
                  backgroundColor: 'var(--rose)',
                  opacity: 0.55
                }} data-id="element-644"></div>
                  <span className="text-[9px] text-ink-soft" data-id="element-645">Fev</span>
                </div>
                <div className="w-full flex flex-col items-center justify-end h-full gap-1" data-id="element-646">
                  <div className="w-full rounded-t-md" style={{
                  height: '58px',
                  backgroundColor: 'var(--rose)',
                  opacity: 0.5
                }} data-id="element-647"></div>
                  <span className="text-[9px] text-ink-soft" data-id="element-648">Mar</span>
                </div>
                <div className="w-full flex flex-col items-center justify-end h-full gap-1" data-id="element-649">
                  <div className="w-full rounded-t-md" style={{
                  height: '82px',
                  backgroundColor: 'var(--rose)',
                  opacity: 0.6
                }} data-id="element-650"></div>
                  <span className="text-[9px] text-ink-soft" data-id="element-651">Abr</span>
                </div>
                <div className="w-full flex flex-col items-center justify-end h-full gap-1" data-id="element-652">
                  <div className="w-full rounded-t-md" style={{
                  height: '72px',
                  backgroundColor: 'var(--rose)',
                  opacity: 0.55
                }} data-id="element-653"></div>
                  <span className="text-[9px] text-ink-soft" data-id="element-654">Mai</span>
                </div>
                <div className="w-full flex flex-col items-center justify-end h-full gap-1" data-id="element-655">
                  <div className="w-full rounded-t-md" style={{
                  height: '105px',
                  backgroundColor: 'var(--rose)',
                  opacity: 0.7
                }} data-id="element-656"></div>
                  <span className="text-[9px] text-ink-soft" data-id="element-657">Jun</span>
                </div>
                <div className="w-full flex flex-col items-center justify-end h-full gap-1" data-id="element-658">
                  <div className="w-full rounded-t-md" style={{
                  height: '95px',
                  backgroundColor: 'var(--rose)',
                  opacity: 0.65
                }} data-id="element-659"></div>
                  <span className="text-[9px] text-ink-soft" data-id="element-660">Jul</span>
                </div>
                <div className="w-full flex flex-col items-center justify-end h-full gap-1" data-id="element-661">
                  <div className="w-full rounded-t-md" style={{
                  height: '120px',
                  backgroundColor: 'var(--rose)',
                  opacity: 0.8
                }} data-id="element-662"></div>
                  <span className="text-[9px] text-ink-soft" data-id="element-663">Ago</span>
                </div>
                <div className="w-full flex flex-col items-center justify-end h-full gap-1" data-id="element-664">
                  <div className="w-full rounded-t-md relative" style={{
                  height: '140px',
                  backgroundColor: 'var(--rose)'
                }} data-id="element-665">
                    <div className="absolute -top-5 left-1/2 -translate-x-1/2 text-[10px] font-bold text-rose whitespace-nowrap" data-id="element-666">
                      Set*
                    </div>
                  </div>
                  <span className="text-[9px] font-bold text-rose" data-id="element-667">Set</span>
                </div>
              </div>
            </div>

            {/* Floating Chip */}
            <div className="absolute -bottom-6 -right-4 lg:-right-12 bg-white rounded-2xl p-4 shadow-[0_8px_32px_rgba(0,0,0,0.12)] z-20 animate-[float_6s_ease-in-out_infinite]" data-id="element-668">
              <p className="text-sm font-medium text-ink mb-1" data-id="element-669">
                Margem média 58%
              </p>
              <div className="inline-flex items-center gap-1 bg-green-soft text-[#059669] px-2 py-0.5 rounded text-xs font-bold" data-id="element-670">
                ↑ +4% vs mês anterior
              </div>
            </div>
          </div>
        </Reveal>

        {/* Right: Text */}
        <Reveal delay={0.2} data-id="element-671">
          <div data-id="element-672">
            <span className="text-xs font-bold tracking-widest text-ink-soft uppercase mb-4 block" data-id="element-673">
              O CHOQUE QUE TODA ARTESÃ TEM
            </span>
            <h2 className="font-serif font-bold text-[26px] md:text-[clamp(34px,4vw,48px)] tracking-[-0.02em] text-ink mb-6 leading-tight" data-id="element-674">
              Quanto você está deixando de ganhar agora?
            </h2>
            <p className="text-[15px] md:text-[17px] leading-[1.6] text-ink-soft mb-8" data-id="element-675">
              Toda artesã que começa a usar a Aurora passa pela mesma
              descoberta: "eu tava perdendo dinheiro nesse produto". Não é
              mágica. É só finalmente ver o número que sempre esteve ali —
              escondido no caderno, no Excel da sobrinha, na cabeça.
            </p>
            <a href="#preco" className="inline-flex items-center gap-3 bg-rose text-white px-8 py-3.5 rounded-full hover:bg-rose-deep transition-colors font-medium no-underline" data-id="element-676">
              Quero descobrir o meu número
              <ArrowRight size={18} data-id="element-677" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>;
};